if (!customElements.get('marks-rewards')) {
  class MarksRewards extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.splides = [];
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.init();
    }

    init() {
      if (typeof window.Splide !== 'undefined') {
        this.mountSliders();
        return;
      }

      const checkInterval = window.setInterval(() => {
        if (typeof window.Splide !== 'undefined') {
          window.clearInterval(checkInterval);
          this.mountSliders();
        }
      }, 100);

      window.setTimeout(() => {
        window.clearInterval(checkInterval);
      }, 10000);
    }

    mountSliders() {
      const sliders = this.querySelectorAll('[data-marks-rewards-slider]');

      sliders.forEach((slider) => {
        if (slider.dataset.sliderMounted === 'true') return;

        const totalSlides = slider.querySelectorAll('.splide__slide').length;
if (!totalSlides) return;

const isDesktopPeek = totalSlides >= 4;

const desktopPerPage = isDesktopPeek ? 3 : totalSlides;
const tabletPerPage = totalSlides >= 2 ? 2 : totalSlides;

const desktopPadding = isDesktopPeek
  ? { left: '196px', right: '12%' }
  : { left: '0px', right: '0px' };

const mobileRightPadding = totalSlides > 1 ? '18%' : '0px';

const showPagination = slider.dataset.pagination === 'true' && totalSlides > 1;
const showArrows = slider.dataset.arrows === 'true' && totalSlides > 1;

        slider.dataset.sliderMounted = 'true';

        if (totalSlides >= 4) {
          slider.classList.add('has-desktop-peek');
        } else {
          slider.classList.remove('has-desktop-peek');
        }

        const splide = new Splide(slider, {
          type: 'slide',
          arrows: showArrows,
          pagination: showPagination,
          drag: totalSlides > 1,
          rewind: false,
          speed: 500,
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
          gap: '32px',
          perMove: 1,
          flickMaxPages: 1,
          updateOnMove: true,
          perPage: desktopPerPage,
          padding: desktopPadding,
          // padding: {
          //   left: '0px',
          //   right: desktopRightPadding,
          // },
          classes: {
            arrows: 'splide__arrows marks-rewards__arrows',
            arrow: 'splide__arrow marks-rewards__arrow',
            prev: 'splide__arrow--prev marks-rewards__arrow marks-rewards__arrow--prev',
            next: 'splide__arrow--next marks-rewards__arrow marks-rewards__arrow--next',
            pagination: 'splide__pagination marks-rewards__pagination',
            page: 'splide__pagination__page marks-rewards__pagination-dot',
          },
          breakpoints: {
            1023: {
              gap: '20px',
              perPage: tabletPerPage,
              padding: {
                left: '0px',
                right: '0px',
              },
            },
            767: {
              gap: '12px',
              perPage: 1,
              padding: {
                left: '0px',
                right: mobileRightPadding,
              },
            },
          },
        });

        if (showArrows) {
          splide.on('arrows:mounted', (prev, next) => {
            const arrowIcon = `
              <span class="marks-rewards__arrow-icon" aria-hidden="true">
                <svg viewBox="0 0 27 17" xmlns="http://www.w3.org/2000/svg">
                  <path d="M26.667 9.81849L26.6672 7.15196H5.10467L10.3709 1.88561L8.48534 0L0 8.48529L8.48534 16.9706L10.3709 15.0849L5.10453 9.81863L26.667 9.81849Z" />
                </svg>
              </span>
            `;

            if (prev) {
              prev.innerHTML = arrowIcon;
              prev.setAttribute('aria-label', 'Previous slide');
            }

            if (next) {
              next.innerHTML = arrowIcon;
              next.setAttribute('aria-label', 'Next slide');
            }
          });
        }

        if (showPagination) {
          splide.on('pagination:mounted', (data) => {
            data.items.forEach((item, index) => {
              item.button.innerHTML = `
                <span class="marks-rewards__pagination-icon" aria-hidden="true">
                  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.5 0L15.5 7.5L23 11.5L15.5 15.5L11.5 23L7.5 15.5L0 11.5L7.5 7.5L11.5 0Z" fill="white"/>
                  </svg>
                </span>
              `;
              item.button.setAttribute('aria-label', `Go to slide ${index + 1}`);
            });
          });
        }

        splide.mount();
        this.splides.push(splide);
      });
    }
  }

  customElements.define('marks-rewards', MarksRewards);
}